// extracted by mini-css-extract-plugin
export default {"container":"TextInput_container__R8wBl","label":"TextInput_label__khkJG","input":"TextInput_input__325Gh"};